import { withInstall } from '@jdesign-vue/utils'

import Text from './src/text.vue'

export const JdText = withInstall(Text)
export default JdText

export * from './src/text'
